import { TFormalOffer } from './formalOffers.types';
import { getIsRCFOffer } from './getIsRCFOffer';

export const getHasOnlyRCFOffer = (formalOffers: TFormalOffer[]) => {
    return (
        formalOffers.length === 1 &&
        Boolean(formalOffers.find((offer) => getIsRCFOffer(offer)))
    );
};
